import React from 'react';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useIsAccountEnabled } from 'src/hooks/use-is-account-enabled';
import { RemoteComponentSlot, useRemoteComponent } from 'src/hooks/use-remote-component';
import { Navigation } from 'src/dispensary/core-menu/components/header/navigation';
import StoreFrontHeader from 'src/dispensary/core-menu/components/core-menu-header/store-front-header';

import { resolveSurfaceColor } from '../fields/tokens';

type PageRootProps = {
  backgroundColor?: string;
  children: React.ReactNode;
  showHeader?: boolean;
  showNavigation?: boolean;
};

function isRegionEnabled(value: unknown): boolean {
  return value !== false;
}

/**
 * Shared root render for the CMS editors (standalone page + menu landing page).
 * Conditionally shows the StoreFront header and navigation around the page content.
 */
export function PageRootRender({
  backgroundColor = 'surface',
  children,
  showHeader = true,
  showNavigation = true,
}: PageRootProps): JSX.Element {
  const headerEnabled = isRegionEnabled(showHeader);
  const navEnabled = isRegionEnabled(showNavigation);
  const resolvedBackgroundColor = resolveSurfaceColor(backgroundColor);
  const pageBackgroundColor =
    backgroundColor === 'surface' ? `var(--dcm-cms-page-bg, ${resolvedBackgroundColor})` : resolvedBackgroundColor;

  const { dispensary } = useDispensary();
  const isAccountEnabled = useIsAccountEnabled();
  const ResolvedNavigation = useRemoteComponent(RemoteComponentSlot.Navigation, { fallback: Navigation });

  return (
    <div
      style={
        {
          '--cms-page-background-color': pageBackgroundColor,
          backgroundColor:
            'var(--cms-page-background-color, var(--dcm-cms-page-bg, var(--dcm-color-surface, #ffffff)))',
          minHeight: '100vh',
          width: '100%',
        } as React.CSSProperties
      }
    >
      {headerEnabled && <StoreFrontHeader />}
      {navEnabled && dispensary && <ResolvedNavigation dispensary={dispensary} isAccountEnabled={isAccountEnabled} />}
      {children}
    </div>
  );
}
